/**
 * Asks for the player's name: once, the first time they start any game, and
 * again only when they choose "Change" on Home. Required, trimmed, capped at
 * NAME_MAX_LENGTH (the server's limit).
 */
import { useEffect, useState } from 'react';
import { cleanName } from '../../worker/protocol';
import { NAME_MAX_LENGTH, savePlayerName } from '../lib/playerName';
import { Sheet } from './Sheet';

export function NameSheet({
  open,
  initial,
  first,
  onSave,
  onClose,
}: {
  open: boolean;
  /** The current name, when changing it. */
  initial: string;
  /** First time: "What's your name?" and Continue; otherwise Save. */
  first: boolean;
  onSave: (name: string) => void;
  onClose: () => void;
}) {
  const [draft, setDraft] = useState(initial);
  // Start from the current name each time the sheet opens.
  useEffect(() => {
    if (open) setDraft(initial);
  }, [open]);
  const clean = cleanName(draft);
  return (
    <Sheet open={open} onClose={onClose} title={first ? 'What’s your name?' : 'Your name'} labelledBy="name-title" className="online-sheet name-sheet">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const saved = savePlayerName(draft);
          if (saved) onSave(saved);
        }}
      >
        {first && <p className="confirm-text name-why">It goes on the scorecard, here and in games with friends.</p>}
        <label className="field">
          {/* The sheet's title already asks; the label stays for screen readers. */}
          <span className="sr-only">Your name</span>
          <input
            id="player-name"
            data-autofocus
            value={draft}
            maxLength={NAME_MAX_LENGTH}
            autoComplete="nickname"
            autoCapitalize="words"
            enterKeyHint="done"
            placeholder="Sam"
            onChange={(e) => setDraft(e.target.value)}
          />
        </label>
        <button className="btn btn-gold btn-big wide-btn" type="submit" disabled={!clean}>
          {first ? 'Continue' : 'Save'}
        </button>
      </form>
    </Sheet>
  );
}
